module.exports = __webpack_public_path__ + "resources/img/img_security_chakramax_dac.e82c8d1e735f8739252c3d3a2ecf1153.png";